import { gql } from '@apollo/client';

export const ALL_SCHOOL_PHASES = gql`
  query AllSchoolPhases {
    schoolPhases: getSchoolPhases {
      id
      name
    }
  }
`;
